import styled, { css } from 'styled-components'
import { size } from 'ui/themes/utils'

import Div from 'ui/elements/Div'

export const ActionGroup = styled(Div)`
  text-align: right;

  > *:not(:first-child) {
    margin-left: ${size('margin')};
  }

  * {
    display: inline-block;
  }

  ${(props) => props.float && css`
    float: right;
  `}

  ${(props) => props.left && css`
    text-align: left;
  `}

  ${({ flex }) => flex && css`
    display: flex;
  `}

  ${({ align }) => align && css`
    align-items: ${align};
  `}

  ${({ justify }) => justify && css`
    justify-content: ${justify};
  `}

  ${({ spacing }) => spacing && css`
    > *:not(:first-child) {
      margin-left: ${size('margin', spacing)};
    }
  `}
`
